// Palette

export default { root: {} };
